import { useFilePreview } from '../../File'
import { ICON_HEIGHT_40, IconSpinner } from '../../Icon'

import * as styles from './ImagePreview.module.css'

function ImagePreview({
  className = styles.ImagePreview,
  file: image,
  getFileById,
  scope,
  subject,
}) {
  const { file, loading } = useFilePreview({
    apiParams: { object_id: subject, scope },
    file: image,
    getFileById,
  })

  return !file || loading ? (
    <IconSpinner size={ICON_HEIGHT_40} />
  ) : (
    <img alt='preview' className={className} src={file?.origin} />
  )
}

export default ImagePreview
